<div class="find-a-background-web" (click)="$event.stopPropagation()">
    <div class="menu-row-1">
        <div class="menu-label-location">{{locationText}}</div>
        <div class="menu-btn-clear" (click)="onClearLocationFilter()">{{clearBtnText}}</div>
    </div>
    <div class="menu-row-2">
        <input class="menu-input-location" 
               [(ngModel)]="queryCityOrZip" 
               (ngModelChange)="filterCityZipOptions($event)"
               [matAutocomplete]="cityZipAuto"
               type="text" 
               placeholder="{{locationPlaceholderText}}"
               [attr.tabindex]="-1">
        <mat-autocomplete #cityZipAuto="matAutocomplete">
            <mat-option *ngFor="let option of filteredCityZipOptions$ | async" [value]="option">
                {{option}}
            </mat-option>
        </mat-autocomplete>
    </div>
    <div class="menu-row-3">
        <div class="distance-label">{{distanceText}}</div>
    </div>
    <div class="menu-row-4">
        <div class="distance-slider-container">
            <input type="range" min="0" max="4" step="1" [(ngModel)]="distanceSliderValue" class="distance-slider">
            <div class="distance-labels">
                <span (click)="setDistanceFilterValue(5)" style="left:0%">5</span>
                <span (click)="setDistanceFilterValue(10)" style="left:22.75%">10</span>
                <span (click)="setDistanceFilterValue(15)" style="left:46%">15</span>
                <span (click)="setDistanceFilterValue(25)" style="left:69%">25</span>
                <span (click)="setDistanceFilterValue(50)" style="left:94.5%">50</span>
            </div>
        </div>
    </div>
    <div class="menu-row-5">
        <button class="menu-btn-apply" (click)="onApplyLocationFilter()">{{applyBtnText}}</button>
    </div>
</div>
